// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"13":"d8bc0c19","70":"968ecb9c","298":"16181b02","546":"5999a150","669":"4a24a1e5","787":"1199a6d1"}[chunkId] + ".chunk.js";
};